import { Text, Tooltip } from "@fluentui/react-components";
import { Info16Regular } from "@fluentui/react-icons";
import { useAtomValue } from "jotai";
import { devices } from "library/constants";
import { formatNumber, formatNumberShort } from "library/utils";
import { useCalculatedBenefitCosts } from "pages/Dashboard/hooks/useCalculatedBenefitCosts";
import { useTranslation } from "react-i18next";
import { selectedBenefitCurrencyAtom } from "store/index";
import styled from "styled-components";

import { ButtonWithTooltip } from "components/ButtonWithTooltip/ButtonWithTooltip";
import { Grow } from "components/effects/Grow";
import { Flex } from "components/styled";
import { useIsMobile } from "hooks/useIsMobile";

export function PaymentsPerCategory() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const selectedCurrency = useAtomValue(selectedBenefitCurrencyAtom);

  const { totalBenefitsCostPerCategory, totalBenefitsCost } = useCalculatedBenefitCosts();

  const total = totalBenefitsCost.size;

  return (
    <Container data-help="dashboard-per-category">
      <Flex $justify="space-between" width={"100%"} style={{
          height: "35px"
        }}>
        <Title weight="bold">
          {t('hbh.perCategory.label')} ({selectedCurrency})
        </Title>
        {/* <ButtonWithTooltip tooltipContent={t("TODO")} icon={<Info16Regular />} /> */}
      </Flex>
      <CategoryPaymentsList>
        {totalBenefitsCostPerCategory.slice(0, 4).map((item) => {
          const width = (item.size / total) * 100;

          return (
            <CategoryPayments key={item.id}>
              <Tooltip relationship="description" content={item.name}>
                <Text
                  weight="semibold"
                  align="start"
                  wrap={false}
                  truncate
                  block
                  style={{
                    overflow: "hidden",
                  }}
                >
                  {item.name}
                </Text>
              </Tooltip>
              <Line>
                <Grow width={width} key={item.id}>
                  <FilledLine $width={width} />
                </Grow>
              </Line>
              <Text weight="semibold" align="end">
                {isMobile ? formatNumberShort(item.size) : formatNumber(item.size)}
              </Text>
            </CategoryPayments>
          );
        })}
      </CategoryPaymentsList>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: 0px 10px 10px;
  gap: 20px;
  background: ${(props) => props.theme.semanticColors.cardStandoutBackground};
  border: 1px solid ${(props) => props.theme.palette.neutralLight};
  border-radius: 6px;
`;
const Title = styled(Text)`
  font-size: 15px;
`;

const CategoryPaymentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
const CategoryPayments = styled.div`
  display: grid;
  grid-template-columns: 70px 3fr 1fr;
  height: 20px;

  gap: 5px;
  justify-content: space-between;

  @media only screen and ${devices.md} {
    grid-template-columns: 100px 5fr 1fr;
  }
`;

const Line = styled.div`
  width: 100%;
  background: ${(props) => props.theme.palette.neutralLighterAlt};
  height: 16px;

  border-radius: 3px;
`;
const FilledLine = styled.div<{ $width: number }>`
  height: 100%;
  background: ${(props) => props.theme.palette.accent};
  border-radius: 3px;
  width: ${(props) => props.$width}%;
`;
